export const DEFAULT_FEATURE_GATE_ERROR_MESSAGE = 'feature gate blocked';
class FeatureGateError extends Error {
  constructor(message, extra) {
    super(message);
    this.name = this.constructor.name;
    this.extra = extra;
  }
}

export default FeatureGateError;
